var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"el-fade-in"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_show),expression:"is_show"}],staticClass:"bg_000000",style:({ width: _vm.width, heght: _vm.heght }),attrs:{"src":_vm.src,"alt":""},on:{"load":_vm.img_back}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e9efce8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public-img/public-img.vue
// module id = cT3+
// module chunks = 11